/**
 * Centralized workflow tag definitions
 * This is the single source of truth for workflow tags and their display names
 */
export const WORKFLOW_TAGS = {
  PPM: { value: 'PPM', label: 'NetPPM' },
  MFR: { value: 'MFR', label: 'MFR' }
} as const;

/**
 * Get the user-friendly display name for a workflow tag
 * @param tag - The workflow tag value (e.g., 'PPM', 'MFR')
 * @returns The display label (e.g., 'NetPPM', 'MFR')
 */
export const getWorkflowDisplayName = (tag: string): string => {
  const workflow = Object.values(WORKFLOW_TAGS).find(w => w.value === tag);
  return workflow?.label || tag;
};
